<template>
	<b-modal
		id="design-modal"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		size="md"
		v-model="context.design"
	>
		<div class="modalheading d-flex align-items-center justify-content-between">
			Activate Topic
			<img src="../../../assets/deletepopupicon.svg" alt="" />
		</div>
		<div @click="$bvModal.hide('design-modal')" class="xMarkCancel">
			<img src="../../../assets/xmark.svg" alt="" />
		</div>
		<hr />
		<div
			style="margin: auto"
			v-if="context.LoaderStatus"
			class="d-flex justify-content-center mb-3"
		>
			<b-spinner label="Loading..."></b-spinner>
		</div>
		<div v-else>
			<div>
				<div class="tcg-modal-grey p-2">
					<div class="tcg-modal-head">Topic name</div>
					<div class="d-flex align-items-center justify-content-between">
						<div class="tcg-modal-head-2">{{ this.theTopicName }}</div>
						<div class="graph-subtext">
							Total Test : <b>{{ totalTestCount }}</b>
						</div>
					</div>
				</div>
				<div class="mt-3 answertext">
					Please select the tests you would like to activate for this topic.
				</div>
			</div>
			<div class="tcg-modal-overflow">
				<!-- WHEN TOPIC IS ACTIVE -->

				<!-- WHEN TOPIC IS INACTIVE -->

				<div
					v-for="(i, index) in totalTestArr"
					:key="index"
					class="tcg-modal-card m-2"
				>
					<div class="d-flex align-items-center justify-content-between">
						<div class="tcg-test-name pt-1">
							{{ i.name }}
						</div>
						<div
							class="tcg-deactivate-box d-flex align-items-center justify-content-between p-1"
						>
							<div
								@click="toggleActivateVal(index, i)"
								:class="
									i.view
										? 'tcg-active-text-green pointer'
										: 'tcg-disable-text pointer'
								"
							>
								Activate
							</div>

							<div
								@click="toggleActivatenext(index, i)"
								:class="
									i.view
										? 'tcg-disable-text pointer'
										: 'tcg-active-text-red pointer'
								"
								class="tcg-disable-text pointer"
							>
								Deactivate
							</div>
						</div>
					</div>
					<div
						class="d-flex align-items-center justify-content-between mt-3 pr-2"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div class="topic-gt-tctxt mr-2">Candidates</div>
							<div class="topic-gt-tccounttxt">
								{{ actualres.testIDs[index].candidateCount }}
							</div>
						</div>
						<div class="d-flex align-items-center justify-content-between">
							<div class="topic-gt-tctxt mr-2">Sections</div>
							<div class="greennumbertext">
								{{ actualres.testIDs[index].numberOfSections }}
							</div>
						</div>
						<div class="d-flex align-items-center justify-content-between">
							<div class="topic-gt-tctxt mr-2">Marks</div>
							<div class="proct-gt-candcounttxt">
								{{ actualres.testIDs[index].marks }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="editTopicModal()">Okay</b-button>
			</div>
		</div>
	</b-modal>
</template>

<script>
import { editTopicModal } from "../asynchronous";
export default {
	name: "ActivateTopicModal",
	data() {
		return {};
	},
	props: {
		theTopicName: String,
		totalTestCount: Number,
		totalTestArr: Array,
		actualres: Object,
		context: Object,
	},
	methods: {
		async editTopicModal() {
			await editTopicModal(this.context);
		},
		toggleActivateVal(ind, allTestValue) {
			this.totalTestArr[ind].view = true;
			this.$forceUpdate();
			let currentTestId = allTestValue.testID;
			if (!this.context.allTestIds.includes(currentTestId)) {
				this.context.allTestIds.push(allTestValue.testID);
			}
		},
		toggleActivatenext(ind, allTestValue) {
			this.totalTestArr[ind].view = false;
			this.$forceUpdate();
			let currentTestId = allTestValue.testID;
			const Currentindex = this.context.allTestIds.indexOf(currentTestId);
			if (this.context.allTestIds.includes(currentTestId)) {
				this.context.allTestIds.splice(Currentindex, 1);
			}
		},
	},
};
</script>
